import { baseUrl } from "../config";
let token = null;
let timeout = null;
const setToken = (newToken) => {
    if (newToken) {
        localStorage.setItem('auth.token', newToken);
    }
    else {
        localStorage.removeItem('auth.token');
    }
    token = newToken;
    if (timeout) {
        clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
        const xhr = new XMLHttpRequest();
        const listener = () => {
            if (xhr.readyState === 4) {
                const newToken = xhr.getResponseHeader('token');
                if (newToken) {
                    setToken(newToken);
                }
            }
        };
        xhr.open('GET', `${baseUrl}/auth/renew`);
        if (null !== getToken()) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + getToken());
        }
        xhr.addEventListener('readystatechange', listener);
        xhr.send();
    }, 50 * 10 * 1000);
};
const getToken = () => {
    if (!token) {
        token = localStorage.getItem('auth.token');
    }
    return token;
};
export { setToken };
export default getToken;
